import { initializeApp } from "firebase/app";
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB0Soysu0cqH33d5zsbf46PVJF-tSpshQM",
  authDomain: "kailin-website.firebaseapp.com",
  projectId: "kailin-website",
  storageBucket: "kailin-website.firebasestorage.app",
  messagingSenderId: "903661973342",
  appId: "1:903661973342:web:3c1482b605a329253e69cf",
  measurementId: "G-2WV5D3X6N8"
};

const app = initializeApp(firebaseConfig);
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager() // Keeps cache synced across browser tabs
  })
});
export const storage = getStorage(app);
export const auth = getAuth(app);